/* eslint-disable import/prefer-default-export */
import { View } from '@src/utils/graph.helpers'
import type { TotalsPublicObjects } from '../external.lists/default.state'
import type { Graph } from '@src/components/vis.js.network.vis/models'
import type { SearchResult } from '../autocomplete.query'
import type {
  ResourceDetails,
  AutoCompleteRespTypeEnum,
  SensitivePrivilegeInfo
} from '@src/endpoints/services/graphQueryMgr.service'

export interface FailedObject {
  name?: string
  coordinates?: [number, number]
  radius?: number
  id?: string
}

export const defaultState = {
  users: 0,
  activeUsers: 0,
  objects: 0,
  publicObjects: 0,
  privileges: 0,
  usedPrivileges: 0,
  accounts: 0,
  instances: 0,
  publicInstances: 0,
  networks: 0,
  publicNetworks: 0,
  unknownAccountCount: 0,
  unknownNetworkCount: 0,
  unusedSensitivePrivs: {} as SensitivePrivilegeInfo,
  publicObjectsCounts: {} as TotalsPublicObjects,
  userCounts: [] as { used: number; total: number }[],
  objectCounts: [] as { used: number; total: number }[],
  publicCounts: [] as { used: number; total: number }[],
  graph: {} as Graph,
  table: [] as SearchResult[],
  objectsList: [] as ResourceDetails[],
  identitiesList: [] as ResourceDetails[],
  policiesList: [] as ResourceDetails[],
  failedObjects: [] as FailedObject[],
  mapSummary: '',
  searchQuery: '',
  isPending: true,
  isPendingGraph: false,
  errors: null as { used: number; total: number }[] | null,
  autoCompleteRespType: null as AutoCompleteRespTypeEnum,
  sqlQueryUserUsage: '',
  selectedGraphView: View.access,
  highCount: 0,
  mediumCount: 0,
  lowCount: 0,
  totalCount: 0,
  openCount: 0
}
